import React, { useEffect, useState } from "react";

function CountdownTimer({ targetDate }) {
  const calculateTimeLeft = () => {
    const difference = +targetDate - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        gün: Math.floor(difference / (1000 * 60 * 60 * 24)),
        saat: Math.floor((difference / (1000 * 60 * 60)) % 24),
        dakika: Math.floor((difference / 1000 / 60) % 60),
        saniye: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearTimeout(timer);
  });

  const labels = {
    gün: "Gün",
    saat: "Saat",
    dakika: "Dakika",
    saniye: "Saniye"
  };

  return (
    <div className="countdown">
      {Object.keys(timeLeft).length === 0 ? (
        <span>Süre doldu!</span>
      ) : (
        Object.keys(labels).map((interval) => (
          <div className="countdown-item" key={interval}>
            <span>{timeLeft[interval] !== undefined ? String(timeLeft[interval]).padStart(2, '0') : '00'}</span>
            <span className="countdown-label">{labels[interval]}</span>
          </div>
        ))
      )}
    </div>
  );
}

export default CountdownTimer; 